var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZone1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3840 2061",
    style: {
      enableBackground: "new 0 0 3840 2061"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "zone_1_path"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FA553A",
      strokeWidth: 41.9615,
      strokeMiterlimit: 10
    },
    d: "M1748.335,381.547h-464.731 c-39.442,0-77.738,7.739-113.824,23.002c-34.822,14.728-66.083,35.801-92.915,62.631c-26.831,26.831-47.903,58.092-62.632,92.915 c-15.263,36.086-23.003,74.383-23.003,113.825v101.387l-221.824,0.916c-43.925,0.181-86.546,8.953-126.677,26.072 c-38.737,16.523-73.5,40.086-103.326,70.035c-29.824,29.947-53.244,64.809-69.608,103.614 c-16.953,40.203-25.547,82.859-25.547,126.784v30.158c0,55.575,21.642,107.824,60.939,147.123 c23.876,23.876,52.713,41.372,84.37,51.346c1.405,43.303,10.625,85.352,27.461,125.157c17.709,41.868,43.047,79.455,75.31,111.717 c32.263,32.263,69.85,57.601,111.718,75.309c43.377,18.348,89.421,27.651,136.849,27.651h289.914"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZone1);
export default __webpack_public_path__ + "static/media/zone_1.34429836.svg";
export { ForwardRef as ReactComponent };